import { type SyncPullMembershipDataResponse } from '@airship-platform/proposal-sync-feature/schema';
import { type RxCollection, type RxCollectionCreator } from 'rxdb';
import { identityMigration } from '../../rxdb/utils/collectionDefaults';

const membershipTypesSchema = {
  version: 2,
  primaryKey: 'membershipTypeId',
  type: 'object',
  properties: {
    membershipTypeId: { type: 'string', maxLength: 36 },
    billingTemplateId: { type: ['string', 'null'] },
    discount: { type: 'number' },
    discountMode: { type: 'string' },
    discounts: { type: 'array' },
    durationBilling: { type: 'array' },
    useMembershipPricingTable: { type: 'boolean' },
  },
  required: ['membershipTypeId'],
} as const;

const invoiceTemplatesSchema = {
  version: 0,
  primaryKey: 'invoiceTemplateId',
  type: 'object',
  properties: {
    invoiceTemplateId: { type: 'string', maxLength: 36 },
    items: { type: 'array' },
  },
  required: ['invoiceTemplateId'],
} as const;

export const membershipDataCollections: Record<string, RxCollectionCreator> = {
  membership_types: {
    autoMigrate: false,
    schema: membershipTypesSchema,
    migrationStrategies: {
      1: identityMigration,
      2: identityMigration,
    },
  },
  invoice_templates: {
    autoMigrate: false,
    schema: invoiceTemplatesSchema,
  },
};

export type MembershipType =
  SyncPullMembershipDataResponse['membershipTypes'][number];
export type InvoiceTemplate =
  SyncPullMembershipDataResponse['invoiceTemplates'][number];

export type MembershipDataCollections = {
  membership_types: RxCollection<MembershipType>;
  invoice_templates: RxCollection<InvoiceTemplate>;
};
